import templateStr from 'text!./policy-pending-cancel_MSF.html';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            'tableTitle': '@',
            'loading': '=',
            'pageListData': '=?',
            'getLoadByOffset': '=',
            'pageSize': '@'
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PolicyPendingCancellationDirective_MSF/PolicyPendingCancel_MSF.js
// module id = 1757
// module chunks = 0